module.exports = __webpack_public_path__ + "static/media/TRIAL-2.7ef84c98.mp3";